import type { TapSprite } from '../themes/types';

// Semantic tap-sprite key → rendered emoji. Shared by the tap effect
// runtime (chooses the character passed to flyStar/spawnSparkles) and by
// the editor's tap-effect section (renders selectable chips).
export const TAP_SPRITE_EMOJI: Readonly<Record<TapSprite, string>> = {
  star: '⭐',
  heart: '💖',
  sparkle: '✨',
  confetti: '🎉',
  coin: '💰',
};
